import { Component, Input } from '@angular/core';

import { ShIconLinkComponent } from '../icon-link/icon-link.component';
import { NavigationItem } from '../navigation-item/entities/navigation-item.entity';

@Component({
    standalone: true,
    selector: 'sh-dashboard-navigation',
    templateUrl: './dashboard-navigation.component.html',
    imports: [ShIconLinkComponent],
    styleUrls: ['./dashboard-navigation.component.scss']
})
export class ShDashboardNavigationComponent {
    @Input() title?: string;
    @Input() navigationLinks!: NavigationItem[];
    @Input() rounded: boolean = false;
}
